export default __webpack_public_path__ + "static/media/moralisLogo.fe917697.png";